
  import createMeisterIcons from '../src/createMeisterIcons';

  const Key = createMeisterIcons("key", [["path",{"fill":"currentColor","d":"M6.166 6.166a2.85 2.85 0 0 1 4.035 4.027l-.004.004-.004.004a2.85 2.85 0 0 1-4.027-4.035m4.516 5.576a4.351 4.351 0 1 1 1.06-1.06l6.622 6.621.389-.389a.75.75 0 1 1 1.06 1.061L16.35 21.44a.75.75 0 1 1-1.06-1.06l2.014-2.016-1.626-1.626-1.167 1.166a.75.75 0 1 1-1.06-1.06l1.166-1.167z","key":"09f82f93ee3ab4d8830cea996e97d36ade34618d","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Key
  